import { useMutation } from '@tanstack/react-query'
import {
  exportFamilyApplications,
  ExportFamilyApplicationsParams,
} from './requests'

type UseExportFamilyApplicationsOptions = {
  onSuccess?: (blob: Blob) => void
  onError?: (error: Error) => void
}

export const useExportFamilyApplications = (
  options?: UseExportFamilyApplicationsOptions
) => {
  return useMutation({
    mutationFn: (params: ExportFamilyApplicationsParams) =>
      exportFamilyApplications(params),
    onSuccess: (blob) => {
      options?.onSuccess?.(blob)
    },
    onError: (error: Error) => {
      options?.onError?.(error)
    },
  })
}
